import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"info\"><path d=\"M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 1a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm1 11V9.99A1 1 0 0 0 10 9H9v5.01a1 1 0 0 0 1 .99h1v-1h1v-1h-1ZM8 9h1v1H8V9Zm1-4h2v2H9V5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol